import React, {useEffect, useImperativeHandle, useState} from "react";
import {Col, DatePicker, Form, Input, message, Row, Select, TreeSelect} from "antd";
import {useModel, useModelDispatchers} from "../../../models";
import {CM_ACTION_TYPE} from "../../../utils/constants";
import moment from "moment";
import SupplierService from "../../base/supplier/SupplierService";
import {useHistory} from "react-router";
import {goPage} from "../../layout/pageDefinition";

const dateFormat = 'YYYY-MM-DD';
export default function ({formRef, actionType}) {
    const history = useHistory();
    const [form] = Form.useForm();
    const {closeNav} = useModelDispatchers("nav");
    const [supplier, setSupplier] = useState({});

    const [{userInfo}] = useModel("global");
    const {orgId, orgName, userName,} = userInfo;
    const nowTime = moment().format("YYYY-MM-DD HH:mm:ss");

    const [{invoiceTypeDict, supplierDict, orgDict,},] = useModel("cmDict");

    const [{
        selectedDocument, documentMaterialList, detailStatistics, formExpand, formData
    }, {
        insert, update, setFormData, loadRo, setDocumentMaterialList
    }] = useModel("purchaseRo");
    const {orderStatus = "027001"} = selectedDocument;
    const editable = (
        orderStatus === "027001"
        || orderStatus === "027002"
    );
    //重新计算优惠总金额和总金额
    const reCompute = () => {
        const discount = form.getFieldValue("discount");
        const favorableAmount = form.getFieldValue("favorableAmount");

        const {roTotalNum = 0, roTotalAmount = 0.00, roReceivableAmount = 0.00} = detailStatistics
        const aggregateAmount = (roReceivableAmount * parseFloat(discount) / 100 - parseFloat(favorableAmount)).toFixed(2)
        const discountAmount = (roTotalAmount - aggregateAmount).toFixed(2);
        form.setFieldsValue({
            returnNum: roTotalNum,
            receivableAmount: !!aggregateAmount && !isNaN(aggregateAmount) ? aggregateAmount : 0.00,
            discountAmount: !!discountAmount && !isNaN(discountAmount) ? discountAmount : 0.00,
        });
        setFormData(form.getFieldsValue());
    }
    useEffect(() => {
        reCompute();
    }, [detailStatistics]);

    /*useEffect(() => {
        setFormData({});
    }, []);*/

    useEffect(() => {
        if (actionType === CM_ACTION_TYPE.EDIT) {
            if (selectedDocument) {
                const initFormData = {
                    ...selectedDocument,
                    returnTime: moment(selectedDocument.returnTime, dateFormat)
                }
                form.setFieldsValue(initFormData)

                const {supplierCode, supplierName} = selectedDocument;
                setSupplier({supplierCode, supplierName})
            }
        }
        if (actionType === CM_ACTION_TYPE.INSERT) {
            form.setFieldsValue({
                ...formData,
                // returnTime: moment(),
                orgId: orgId,
                createUser: userName,
                createTime: nowTime,
            })
        }
        setFormData(form.getFieldsValue());
    }, [actionType, selectedDocument])

    useImperativeHandle(formRef, () => ({
        form: () => {
            return form;
        },
        insert: () => {
            if (!!!documentMaterialList || documentMaterialList.length <= 0) {
                message.error("商品明细为空!");
            } else {
                form.validateFields().then(formData => {
                    const {supplierCode, supplierName} = supplier;
                    const data = {
                        ...formData,
                        details: documentMaterialList,
                        supplierCode,
                        supplierName,
                        orgId: orgId,
                        orgName: orgName,
                        createUser: userName,
                    }
                    insert({showMsg: true, data}).then(retData => {
                        // console.log("新增返回结果:", retData);
                        loadRo({showMsg: false, data: retData}).then(() => {
                            closeNav();
                            goPage(history, "2-4-1");
                        });
                    })
                }).catch(ex => {
                    message.error("表单字段校验失败");
                    console.log(ex)
                });
            }

        },
        update: async () => {
            if (!!!documentMaterialList || documentMaterialList.length <= 0) {
                message.error("商品明细为空!");
            } else {
                let formData = await form.validateFields();

                const {id} = selectedDocument;
                const {supplierCode, supplierName} = supplier;
                const data = {...formData, details: documentMaterialList, id, supplierCode, supplierName};
                return await update({showMsg: true, data})
            }
        },
        reset: () => {
            form.resetFields();
        },
    }));

    const onSupplierChange = async (el) => {
        let supplier = await SupplierService.findOne(el["supplierId"]);
        if (supplier) {
            setSupplier(supplier);
            const {supplierPerson, supplierPhone, supplierAddress} = supplier;
            form.setFieldsValue({supplierPerson, supplierPhone, returnAddress: supplierAddress});
        }
    };

    return (
        <Form
            form={form}
            name="purchase_ro_form"
            labelCol={{span: 6}}
            onValuesChange={el => {
                reCompute();
                if (el["supplierId"]) {
                    onSupplierChange(el).then(() => setDocumentMaterialList([]))
                }

            }}
            initialValues={{
                returnTime: moment(),
                favorableAmount: 0.00,
                discount: 100,
                returnNum: 0,

            }}
        >

            <Row>
                <Col span={6}>
                    <Form.Item
                        name="returnCode"
                        label="退货单号"
                    >
                        <Input disabled={true} placeholder="退货单号"/>
                    </Form.Item>
                </Col>
                <Col span={6}>
                    <Form.Item
                        name="supplierId"
                        label="供应商名称"
                        rules={[{required: true, message: '必输字字段',}]}
                    >
                        <Select
                            disabled={actionType === CM_ACTION_TYPE.EDIT}
                            showSearch
                            allowClear={true}
                            placeholder="选择供应商"
                            filterOption={(input, option) => option.label.indexOf(input) >= 0}
                            options={supplierDict}
                            dropdownClassName="dark-select"
                        />
                    </Form.Item>
                </Col>
                <Col span={6}>
                    <Form.Item
                        name="supplierPerson"
                        label="联系人"
                        rules={[{required: true, message: '必输字字段',}]}
                    >
                        <Input disabled={!editable} placeholder="联系人"/>
                    </Form.Item>
                </Col>
                <Col span={6}>
                    <Form.Item
                        name="supplierPhone"
                        label="联系电话"
                        rules={[{required: true, message: '必输字字段',}]}
                    >
                        <Input disabled={!editable} placeholder="联系电话"/>
                    </Form.Item>
                </Col>
            </Row>
            <Row>
                <Col span={6}>
                    <Form.Item
                        name="invoiceType"
                        label="发票类型"
                    >
                        <Select
                            disabled={!editable}
                            showSearch
                            allowClear={true}
                            placeholder="发票类型"
                            filterOption={(input, option) => option.label.indexOf(input) >= 0}
                            options={invoiceTypeDict}
                        />
                    </Form.Item>
                </Col>
                <Col span={6}>
                    <Form.Item
                        name="returnTime"
                        label="退货日期"
                    >
                        <DatePicker disabled={!editable} placeholder="退货日期" style={{width: "100%"}}/>
                    </Form.Item>
                </Col>


                <Col span={6}>
                    <Form.Item
                        name="favorableAmount"
                        label="整单优惠"
                    >
                        <Input disabled={true} placeholder="整单优惠"/>
                    </Form.Item>
                </Col>
                <Col span={6}>
                    <Form.Item
                        name="discount"
                        label="整单折扣"
                        rules={[
                            {required: true, message: '必输字字段',},
                            {pattern: /^(([0-9]\d?)|100)$/g, message: '折扣必须是大于等于0且小于等于100的整数'},
                        ]}
                    >
                        <Input disabled={!editable} placeholder="整单折扣" suffix="%"/>
                    </Form.Item>
                </Col>
            </Row>
            <Row>

                <Col span={6}>
                    <Form.Item
                        name="returnNum"
                        label="退货总数量"
                    >
                        <Input disabled={true} placeholder="退货总数量"/>
                    </Form.Item>
                </Col>
                <Col span={6}>
                    <Form.Item
                        name="discountAmount"
                        label="优惠总金额"
                    >
                        <Input disabled={true} placeholder="优惠总金额"/>
                    </Form.Item>
                </Col>
                <Col span={6}>
                    <Form.Item
                        name="receivableAmount"
                        label="应收总金额"
                        rules={[
                            {required: true, message: '必输字字段',},
                            () => ({
                                validator: (_, value) => {
                                    return (
                                        (value && parseInt(value) >= 0) ? Promise.resolve() : Promise.reject('不能小于零')
                                    )
                                }
                            }),
                        ]}
                    >
                        <Input disabled={true} placeholder="应收总金额"/>
                    </Form.Item>
                </Col>
                {/*<Col span={6}>
                    <Form.Item
                        name="returnDesc"
                        label="退货原因"
                        rules={[{required: true, message: '请输入退货原因',}]}
                    >
                        <Input placeholder="退货原因"/>
                    </Form.Item>
                </Col>*/}
            </Row>
            <Row>
                <Col span={12}>
                    <Form.Item
                        name="returnAddress"
                        label="退货地址"
                        rules={[{required: false, message: '请输入退货地址 ',}]}
                        labelCol={{span: 3}}
                    >
                        <Input disabled={!editable} placeholder="退货地址"/>
                    </Form.Item>
                </Col>
                <Col span={12}>
                    <Form.Item
                        name="returnDesc"
                        label="退货原因"
                        rules={[{required: true, message: '请输入退货原因',}]}
                        labelCol={{span: 3}}
                    >
                        <Input placeholder="退货原因"/>
                    </Form.Item>
                </Col>

            </Row>
            {
                (() => {
                    if (actionType === CM_ACTION_TYPE.EDIT && formExpand) {
                        return <>
                            <Row>
                                <Col span={6}>
                                    <Form.Item
                                        name="orgId"
                                        label="组织机构"
                                    >
                                        <TreeSelect
                                            disabled={true}
                                            showSearch
                                            allowClear
                                            dropdownStyle={{maxHeight: 400, overflow: 'auto'}}
                                            placeholder="请选择组织机构"
                                            treeDefaultExpandAll
                                            onChange={() => {
                                            }}
                                            treeData={orgDict}
                                        />
                                    </Form.Item>
                                </Col>
                                <Col span={6}>
                                    <Form.Item
                                        name="createUser"
                                        label="业务员"
                                    >
                                        <Input disabled={true} placeholder="业务员"/>
                                    </Form.Item>
                                </Col>
                                <Col span={6}>
                                    <Form.Item
                                        name="warehouseMan"
                                        label="库管"
                                    >
                                        <Input disabled={true} placeholder="库管"/>
                                    </Form.Item>
                                </Col>
                                <Col span={6}>
                                    <Form.Item
                                        name="financialStaff"
                                        label="财务"
                                    >
                                        <Input disabled={true} placeholder="财务"/>
                                    </Form.Item>
                                </Col>
                            </Row>
                            <Row>
                                <Col span={6}>
                                    <Form.Item
                                        name="createUser"
                                        label="制单人"
                                    >
                                        <Input disabled={true} placeholder="制单人"/>
                                    </Form.Item>
                                </Col>
                                <Col span={6}>
                                    <Form.Item
                                        name="createTime"
                                        label="制单时间"
                                    >
                                        <Input disabled={true} placeholder="制单时间"/>
                                    </Form.Item>
                                </Col>
                                <Col span={6}>
                                    <Form.Item
                                        name="updateUser"
                                        label="修改人"
                                    >
                                        <Input disabled={true} placeholder="修改人"/>
                                    </Form.Item>
                                </Col>
                                <Col span={6}>
                                    <Form.Item
                                        name="updateTime"
                                        label="修改时间"
                                    >
                                        <Input disabled={true} placeholder="修改时间"/>
                                    </Form.Item>
                                </Col>
                            </Row>
                        </>
                    }
                })()
            }
        </Form>
    )
}